import { Icon } from "./Icon.tsx";

/** Audit finding: the previous 3-crossing-axes snowflake read as a bare
 * asterisk against the rest of the tab-icon family — noticeably lighter
 * than icons like ClimateIcon (sun-behind-cloud) or LandUseIcon
 * (subdivided parcel) that fill their box. Same 4 chevrons + cross
 * arms Lucide's own snowflake uses, still line-only with the same
 * shared `Icon` stroke settings so it matches the family, but with
 * enough visual mass to sit at the same weight as its neighbours in
 * the Project Data menu's own list. */
export function SnowIcon() {
  return (
    <Icon>
      <path d="M2 12h20" />
      <path d="M12 2v20" />
      <path d="m20 16-4-4 4-4" />
      <path d="m4 8 4 4-4 4" />
      <path d="m16 4-4 4-4-4" />
      <path d="m8 20 4-4 4 4" />
    </Icon>
  );
}
